import { Component } from '@angular/core';

@Component({
  selector: 'lib-meters',
  templateUrl: './meters.component.html',
  styleUrls: ['./meters.component.scss'],
  standalone: false
})
export class MetersComponent {

}
